import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateCompetition = async ({ orgId, competitionId, data }) => {
  const url = `v1/orgs/${orgId}/competitions/${competitionId}`
  const response = await axiosInstance.patch(url, JSON.stringify(data))
  return response?.data
}

export default updateCompetition
